{
  "CSAT": {
    "TITLE": "Konuşmanızı oylayın",
    "PLACEHOLDER": "Biraz daha fazla bilgi verin...",
    "RATINGS": {
      "POOR": "😞 Kötü",
      "FAIR": "😑 Zayıf",
      "AVERAGE": "😐 Ortalama",
      "GOOD": "😀 İyi",
      "EXCELLENT": "😍 Mükemmel"
    }
  }
}
